import { render, staticRenderFns } from "./WordsByLengthFinder.vue?vue&type=template&id=b4d15ec0"
import script from "./WordsByLengthFinder.js?vue&type=script&lang=js&external"
export * from "./WordsByLengthFinder.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AdvancedSearchControl: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/finder/AdvancedSearchControl/AdvancedSearchControl.vue').default})
